module.exports = __webpack_public_path__ + "static/media/UmaSwamy@3x.d28329df.png";